import React, { Component } from 'react'

class WithdrawModel extends Component {
    state = {
        isLoading: false,
        withdraw_from: '',
        amount: 0,
        comment: '',
    }

    handleChange = (event) => {
        if (event.target.name == 'amount' && event.target.value > this.props.walletAmount) {
            this.setState({
                [event.target.name]: this.props.walletAmount,
            })
            return
        }

        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    componentDidMount = () => {
        this.setState({
            walletAmount: this.props.walletAmount,
        })
    }

    render() {
        return (
            <div style={{ width: 800, paddingRight: 40 }}>
                <div className="header">
                    <b>Withdrawal Form</b>
                </div>
                <div className="body m-t-20">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Amount</label>
                                <div className="col-9">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter amount"
                                        value={this.state.amount}
                                        name="amount"
                                        onChange={this.handleChange}
                                        max={this.props.walletAmount}
                                        min={0}
                                    />
                                    <span className="text-danger">Max withdrawable amount - {this.props.walletAmount} (Non-Expirable Amount)</span>                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Comment</label>
                                <div className="col-9">
                                    <textarea
                                        rows={3}
                                        className="form-control"
                                        onChange={this.handleChange}
                                        name="comment"
                                        id="comment"
                                        maxLength={200}
                                        placeholder=""
                                        value={this.state.comment}
                                    />
                                    <span className="text-danger font-weight-bold">Note: Only non-expirable wallet amount can be withdrawn.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-right col-6 offset-6">
                            <button
                                onClick={() => this.props.processWithdrawal(this.state)}
                                className="btn hor-grd btn-grd-inverse offset-1"
                                disabled={this.state.amount <= 0}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default WithdrawModel
